<div class="ai-search-container" [attr.dir]="currentLanguage === 'he' ? 'rtl' : 'ltr'">
  <div class="ai-search-content">
    <!-- Logo/Title -->
    <div class="ai-search-header">
      <h1 class="ai-search-title">{{ currentLanguage === 'he' ? 'חיפוש בשפה טבעית' : 'Natural Language Search' }}</h1>
      <p class="ai-search-subtitle">{{ currentLanguage === 'he' ? 'הזן שאילתת חיפוש בשפה חופשית, והמערכת תמיר אותה לחיפוש מובנה' : 'Enter a search query in free text, and the system will convert it to a structured search' }}</p>
    </div>

    <!-- Search Input Area -->
    <div class="ai-search-input-container">
      <div class="search-input-wrapper">
        <textarea
          [(ngModel)]="query"
          [placeholder]="currentLanguage === 'he' ? 'לדוגמה: מצא כלים מתקופת הברונזה באזור ירושלים' : 'For example: Find pottery from the Bronze Age in Jerusalem area'"
          (keydown)="onKeyPress($event)"
          [disabled]="isLoading"
          class="search-textarea"
          rows="1"
          [attr.aria-label]="currentLanguage === 'he' ? 'שאילתת חיפוש' : 'Search query'">
        </textarea>
        <button
          (click)="onSearch()"
          [disabled]="!query.trim() || isLoading"
          class="search-button"
          [attr.aria-label]="currentLanguage === 'he' ? 'חפש' : 'Search'">
          <i *ngIf="!isLoading" class="pi pi-search"></i>
          <i *ngIf="isLoading" class="pi pi-spinner pi-spin"></i>
        </button>
        <button
          *ngIf="isLoading"
          (click)="onCancel()"
          class="cancel-button-inline"
          [attr.aria-label]="currentLanguage === 'he' ? 'ביטול' : 'Cancel'">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Error Message -->
      <div *ngIf="errorMessage" class="error-message">
        <i class="pi pi-exclamation-triangle"></i>
        <span>{{ errorMessage }}</span>
      </div>
    </div>

    <!-- Example Queries (Optional) -->
    <div class="example-queries" *ngIf="!isLoading && !errorMessage">
      <p class="example-title">{{ currentLanguage === 'he' ? 'דוגמאות:' : 'Examples:' }}</p>
      <div class="example-items">
        <button class="example-button" (click)="query = 'מצא לי כלי חרס מתקופת הברזל'">
          מצא לי כלי חרס מתקופת הברזל
        </button>
        <button class="example-button" (click)="query = 'חפש תכשיט זהב מהתקופה הרומית הקדומה '">
         חפש תכשיט זהב מהתקופה הרומית הקדומה
        </button>
        <button class="example-button" (click)="query = 'מודלים תלת מימדיים מירושלים'">
          מודלים תלת מימדיים מירושלים
        </button>
      </div>
    </div>
  </div>
</div>
